/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import moment from 'moment';
import * as actionTypes from './actionTypes';

const initialState = {
  performDisputeResolutionObj: {},
  planType: [],
  selectedPlanType: '',
  selectReportValue: 'Paid Quarter',
  rebateProgram: [],
  errorMsgUnit: [],
  rebateProgramName: [],
  quarterFrom: '',
  fromDateValue: '',
  endDateValue: '',
  adjustmentTypeValue: 'ALL',
  allRebateProgram: false,
  allRebate: [],
  gridData: [],
  allRebateValue: [],
  isLoading: false,
  displayObj: {
    rebateProgramName: [],
    quarterFrom: '',
    allRebate: [],
    fromDateValue: '',
    endDateValue: '',
    allRebateValue: [],
    gridData: [],
  },
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CURRENT_DISPLAY_OBJ_UNIT:
      return { ...state, performResolutionObj: action.screenData };
    case actionTypes.GET_ERROR_MSG_UNIT:
      return { ...state, errorMsgUnit: action.payload };
    case actionTypes.GET_PLAN_TYPE_DATA_UNIT:
      return { ...state, planType: action.payload };
    case actionTypes.GET_REBATE_PROGRAM_UNIT:
      return { ...state, rebateProgram: action.payload };
    case actionTypes.GET_FROM_UNIT:
      return { ...state, quarterFrom: action.payload };
    case actionTypes.GET_REBATE_PROGRAM_NAME_UNIT:
      return { ...state, rebateProgramName: action.payload };
    case actionTypes.SET_ALL_REBATE_PROGRAM_UNIT:
      return { ...state, allRebate: action.payload };
    case actionTypes.SET_LOADING_UNIT_ADJUSTMENT_NDC_LEVEL:
      return { ...state, isLoading: action.payload };
    case actionTypes.SET_ALL_REBATE_PROGRAM_VALUE_UNIT:
      return { ...state, allRebateValue: action.payload };
    case actionTypes.SET_DISPLAY_OBJ_UNIT:
      let tempObj = JSON.parse(JSON.stringify(action.payload));
      return { ...state, displayObj: tempObj };
    case actionTypes.SET_NDC_GRID_DATA_UNIT:
      let displayObj = {
        ...state.displayObj,
        gridData: action.payload,
      };
      return { ...state, gridData: action.payload, displayObj };

    case actionTypes.SET_REFRESH_DATA_UNIT:
      return {
        ...initialState,
        displayObj: state.displayObj,
      };
    case actionTypes.REFRESH_DATA_UNIT_DISPLAY:
      return {
        ...state,
        displayObj: initialState.displayObj,
      };
    case actionTypes.SET_SEARCH_UNIT:
      return { ...state, ...action.payload };
    case actionTypes.SET_PAGINATION_INDEX_UNIT_ADJUSTMENT_AT_NDC_LEVEL:
      return {
        ...state,
        displayObj: { ...state.displayObj, countValue: action.payload },
      };
    default:
      return state;
  }
};
export default reducer;
